function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class PieceFilter.
 *
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { getStructuredPieces } from './reportSelectors';
import Loader from '../common/loader';
import TieredSelect from '../common/lookups/tieredSelect';
import entityComposition from '../common/classes/entityComposition';
class PieceFilter extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const {
      jobPieceFilterReportActions,
      jobPieceIndexQuery,
      pieceOtherFilterReportActions,
      pieceOtherIndexQuery
    } = this.props;
    jobPieceFilterReportActions.serverIndex(jobPieceIndexQuery);
    pieceOtherFilterReportActions.serverIndex(pieceOtherIndexQuery);
  }
  handleChange(selectedValues, newValue) {
    const {
      reportIndexQuery,
      reportActions
    } = this.props;
    const filters = _objectSpread({}, reportIndexQuery.filters);
    let jobPiece = filters.jobPiece ? filters.jobPiece : [];
    let pieceOther = filters.pieceOther ? filters.pieceOther : [];
    if (newValue.entity === 'JobPiece' || newValue.entity === 'JobPieceSection') {
      if (jobPiece.some(piece => piece.id === newValue.id)) {
        // remove this from the list
        jobPiece = _.filter(jobPiece, piece => piece.id !== newValue.id);
      } else {
        jobPiece = jobPiece.concat([{
          id: newValue.id,
          name: newValue.name,
          entity: newValue.entity
        }]);
      }
      reportActions.serverFilter(_objectSpread(_objectSpread({}, filters), {}, {
        jobPiece
      }), reportIndexQuery);
    } else if (newValue.entity === 'JobPieceOther' || newValue.entity === 'JobPiecesOtherParent') {
      if (pieceOther.some(piece => piece.id === newValue.id)) {
        // remove this from the list
        pieceOther = _.filter(jobPiece, piece => piece.id !== newValue.id);
      } else {
        pieceOther = pieceOther.concat([{
          id: newValue.id,
          name: newValue.name,
          entity: newValue.entity
        }]);
      }
      reportActions.serverFilter(_objectSpread(_objectSpread({}, filters), {}, {
        pieceOther
      }), reportIndexQuery);
    } else {
      /* eslint-disable no-console */
      console.error('selected value, not handled', newValue);
      /* eslint-enable no-console */
    }
  }
  render() {
    const {
      reportIndexQuery: {
        filters
      },
      structuredPieces,
      onBack,
      jobPieceLoading,
      pieceOtherLoading
    } = this.props;
    let selections = [];
    if (filters) {
      if (filters.jobPiece) {
        selections = filters.jobPiece;
      }
      if (filters.pieceOther) {
        selections = selections.concat(filters.pieceOther);
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: 100
      }
    }, jobPieceLoading || pieceOtherLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(TieredSelect, {
      data: structuredPieces,
      value: selections,
      onBack: onBack,
      onChange: this.handleChange,
      label: "",
      backLabel: "Back"
    }));
  }
}
PieceFilter.propTypes = {
  jobPieceFilterReportActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobPieceIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  jobPieceLoading: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  pieceOtherIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  pieceOtherLoading: PropTypes.bool.isRequired,
  pieceOtherFilterReportActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      jobPiece: PropTypes.arrayOf(PropTypes.shape({})),
      pieceOther: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  structuredPieces: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export { PieceFilter as TestPieceFilter };
export default entityComposition(PieceFilter, [], {
  reportIndexQuery: state => state.report.indexQuery,
  structuredPieces: getStructuredPieces,
  jobPieceLoading: state => state.jobPieceFilterReport.loading,
  jobPieceIndexQuery: state => state.jobPieceFilterReport.indexQuery,
  pieceOtherLoading: state => state.pieceOtherFilterReport.loading,
  pieceOtherIndexQuery: state => state.pieceOtherFilterReport.indexQuery
}, [
// actions only
'jobPieceFilterReport', 'pieceOtherFilterReport', 'report']);